import { Controller } from "@hotwired/stimulus"

// Card #4393 (tag rework): drag-to-reschedule on the Program sprint board --
// drag a card (a condensed row inside a project tile's floating dropdown)
// from one sprint week's swimlane into another to swap its phase tag (for
// THIS program) rather than writing a due_date.
//
// Mount on the board wrapper spanning every week column:
//   data-controller="sprint-board"
//   data-sprint-board-program-id-value="<program.id>"
// Each week column's drop zone:
//   data-sprint-board-target="dropZone"
//   (sibling week header carries data-sprint-board-target="week" with
//    data-phase-id="<phase id>")
// Each draggable condensed card row:
//   data-sprint-board-target="card"
//   data-card-id="<card.id>"
//   data-reschedule-url="<reschedule_project_card_path>" (blank if the
//   current user isn't this card's assignee -- CardPolicy#reschedule?)
//   draggable="true" only when reschedule-url is present
export default class extends Controller {
  static targets = ["week", "dropZone", "card"]
  static values = { programId: Number }

  dragstart(event) {
    const card = this._cardFromEvent(event)
    if (!card || !card.dataset.rescheduleUrl) {
      event.preventDefault()
      return
    }

    event.dataTransfer.effectAllowed = "move"
    event.dataTransfer.setData("text/plain", card.dataset.cardId)
    this._draggedCard = card
  }

  dragover(event) {
    if (!this._draggedCard) return
    event.preventDefault()
    event.dataTransfer.dropEffect = "move"
  }

  async drop(event) {
    if (!this._draggedCard) return
    event.preventDefault()

    const zone = event.currentTarget
    const phaseId = this._phaseIdFor(zone)
    const rescheduleUrl = this._draggedCard.dataset.rescheduleUrl
    const card = this._draggedCard
    this._draggedCard = null

    if (!phaseId || !rescheduleUrl) return

    const csrf = document.querySelector("meta[name='csrf-token']")?.content

    try {
      const response = await fetch(rescheduleUrl, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "Content-Type": "application/json",
          "X-CSRF-Token": csrf
        },
        body: JSON.stringify({ program_id: this.programIdValue, phase_id: phaseId })
      })

      if (response.ok) {
        const html = await response.text()
        if (html.trim().length > 0) Turbo.renderStreamMessage(html)
      }
    } catch {
      // Silent fail -- the board stays as it was; reload shows the true state
    }
  }

  _cardFromEvent(event) {
    let el = event.target
    while (el && el !== this.element) {
      if (this.cardTargets.includes(el)) return el
      el = el.parentElement
    }
    return null
  }

  _phaseIdFor(zone) {
    // The drop zone is the week column's card-list body; its phase id
    // lives on the sibling "week" target wrapping both the header and this
    // zone.
    const weekEl = zone.closest("[data-phase-id]")
    return weekEl ? weekEl.dataset.phaseId : null
  }
}
